import React, { FC } from "react"
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { Button } from "components/core/button"
import { Card } from "components/core/card"

interface Props {
  name?: string
  description?: string | null
  priceDisplay?: string
  priceInterval?: string
  priceSaved?: string
  includedFeatures?: string[]
  excludedFeatures?: string[]
  hideSubscribeButton?: boolean
  isLoading?: boolean
  onClick?: () => void
}

export const PricingItem: FC<Props> = ({
  name,
  description,
  priceDisplay,
  priceInterval,
  priceSaved,
  includedFeatures,
  excludedFeatures,
  hideSubscribeButton,
  isLoading,
  onClick,
}) => (
  <Card className="flex flex-col p-8 h-full rounded-md lg:rounded-xl">
    <div className="flex-1">
      {priceSaved && (
        <p className="absolute top-0 py-2.5 px-8 bg-indigo-600 rounded-full text-xs font-semibold uppercase tracking-wide text-white left-1/2 -translate-x-1/2 -translate-y-1/2">
          {priceSaved}
        </p>
      )}
      <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-200">{name}</h3>
      <p className="mt-4 flex items-baseline ">
        <span className="text-4xl font-extrabold tracking-tight text-gray-900 dark:text-gray-200">{priceDisplay}</span>
        {priceInterval && <span className="ml-1 text-xl font-semibold">/{priceInterval}</span>}
      </p>
      <p className="mt-6 text-gray-500 dark:text-gray-200">{description}</p>

      <ul role="list" className="mt-6 space-y-6">
        {includedFeatures?.map((feature) => (
          <li key={feature} className="flex">
            <CheckIcon
              className="flex-shrink-0 mt-0.5 w-6 h-6 bg-gray-100 dark:bg-gray-900 dark:bg-opacity-50 rounded-full p-1 text-indigo-500"
              aria-hidden="true"
            />
            <span className="ml-3 text-gray-500 dark:text-gray-200">{feature}</span>
          </li>
        ))}
        {excludedFeatures?.map((feature) => (
          <li key={feature} className="flex opacity-60">
            <XMarkIcon
              className="flex-shrink-0 mt-0.5 w-6 h-6 bg-gray-100 dark:bg-gray-900 dark:bg-opacity-50 rounded-full p-1 text-gray-500 dark:text-gray-200"
              aria-hidden="true"
            />
            <span className="ml-3 text-gray-500 dark:text-gray-200">{feature}</span>
          </li>
        ))}
      </ul>
    </div>

    {!hideSubscribeButton && (
      <Button
        loading={isLoading}
        onClick={onClick}
        variant={name === "Pro" ? "primary" : "secondary"}
        size="big"
        className="justify-center mt-8"
      >
        Subscribe
      </Button>
    )}
  </Card>
)
